"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterToggle = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("@itwin/itwinui-css/css/table.css");
const index_js_1 = require("../../utils/index.js");
const index_js_2 = require("../../Buttons/index.js");
/**
 * Handles showing filter icon and opening filter component.
 */
const FilterToggle = (props) => {
    const { column, className, ...rest } = props;
    (0, index_js_1.useTheme)();
    const [isVisible, setIsVisible] = React.useState(false);
    const close = React.useCallback(() => setIsVisible(false), []);
    const setFilter = React.useCallback((filterValue) => {
        column.setFilter(filterValue);
        close();
    }, [close, column]);
    const clearFilter = React.useCallback(() => {
        column.setFilter(undefined);
        close();
    }, [close, column]);
    const isColumnFiltered = column.filterValue != null && column.filterValue !== '';
    return (React.createElement(React.Fragment, null, column.canFilter && column.Filter && (React.createElement(index_js_1.Popover, { content: column.render('Filter', { close, setFilter, clearFilter }), placement: 'bottom-start', visible: isVisible, onClickOutside: close },
        React.createElement(index_js_2.IconButton, { styleType: 'borderless', isActive: isVisible || isColumnFiltered, className: (0, classnames_1.default)('iui-table-filter-button', className), onClick: (e) => {
                setIsVisible((v) => !v);
                // Prevents from triggering sort
                e.stopPropagation();
            }, ...rest }, isColumnFiltered ? React.createElement(index_js_1.SvgFilter, null) : React.createElement(index_js_1.SvgFilterHollow, null))))));
};
exports.FilterToggle = FilterToggle;
